import type { ToastMessageContext } from '@services/toast-catalog';

/**
 * Erro → orientação. Só associa quando a causa é identificável: código de
 * negócio devolvido pelo backend (`response.data.code`) ou contexto de
 * domínio/ação do toast. Erro desconhecido não ganha associação falsa.
 * Módulo leve: não importa o catálogo.
 */
const PIECE_BY_ERROR_CODE: Readonly<Record<string, string>> = {
  NUTRITION_PLAN_CHANGED: 'problema-rotina-mudou',
  // Licença e limite (licenses.service, license-feature.guard)
  GLOBAL_ACTIVE_ANIMALS_LIMIT_EXCEEDED: 'problema-limite-animais',
  GLOBAL_ACTIVE_ANIMALS_LIMIT_NOT_CONFIGURED: 'problema-limite-animais',
  LICENSE_FEATURE_BLOCKED: 'problema-menu-nao-aparece',
  // Cancelar a última finalização (nutrition-finalization.service)
  CANCELLATION_BLOCKED: 'problema-cancelar-finalizacao-bloqueado',
  STALE_ELIGIBILITY: 'problema-cancelar-finalizacao-bloqueado',
  // Desfazer troca de lote (animal-lot-movement-cancellation, animals.service)
  FUTURE_FORMAL_TRANSFER_EXISTS: 'problema-movimentacao-nao-desfaz',
  FUTURE_PROTECTED_MOVEMENT_EXISTS: 'problema-movimentacao-nao-desfaz',
  HANDLING_REQUIRES_MODULE: 'problema-movimentacao-nao-desfaz',
  MOVEMENT_BATCH_BLOCKED: 'problema-movimentacao-nao-desfaz',
  // Creep (areas.service)
  CREEP_HAS_ACTIVE_DEPENDENCIES: 'problema-creep-nao-desativa',
  // Finalização do contrato (contract-finalization.service, contract-cost-allocation)
  CONTRACT_NO_DESTINATION: 'problema-contrato-nao-finaliza',
  CONTRACT_NO_ECONOMIC_WEIGHT: 'problema-contrato-nao-finaliza',
  CONTRACT_ITEM_WITHOUT_ECONOMIC_WEIGHT: 'problema-contrato-nao-finaliza',
  CONTRACT_SANITARY_PLAN_INVALID: 'problema-contrato-nao-finaliza',
  CONTRACT_RETROACTIVE_GAIN_REPLAY_REQUIRED: 'problema-contrato-nao-finaliza',
};

const PIECE_BY_CONTEXT: Readonly<Partial<Record<`${string}.${string}`, string>>> = {};

export function errorCodeOf(error: unknown): string | undefined {
  if (typeof error !== 'object' || error === null) return undefined;
  const response = (error as { response?: { data?: { code?: unknown } } }).response;
  const code = response?.data?.code;
  return typeof code === 'string' && /^[A-Z][A-Z0-9_]+$/.test(code) ? code : undefined;
}

export function resolveErrorHelpPiece(error: unknown, context?: ToastMessageContext): string | undefined {
  const code = errorCodeOf(error);
  if (code && PIECE_BY_ERROR_CODE[code]) return PIECE_BY_ERROR_CODE[code];
  if (context?.domain && context.action) return PIECE_BY_CONTEXT[`${context.domain}.${context.action}`];
  return undefined;
}

/** Códigos mapeados — usados pelo teste de integridade (todo destino existe). */
export const mappedErrorHelpPieces = (): string[] => [
  ...Object.values(PIECE_BY_ERROR_CODE),
  ...Object.values(PIECE_BY_CONTEXT).filter((value): value is string => Boolean(value)),
];
